import { DtoHasApi } from './dto-has-api.model';
import { Api } from 'src/core/decorators/dto/api.decorator';

@Api('api/app/user')
export class UserBatchUpdateRoleDto extends DtoHasApi {
  roleNames: string[];
  userIds: string[];
}
